import React, { Component } from 'react';
import Link from 'gatsby-link';
import { Container } from 'react-responsive-grid'

import { rhythm, scale } from '../utils/typography'
import avatar from './avatar.jpg'
import keybaseLogo from './keybase.png'
import linkedInLogo from './linkedin.png'
import styles from "./about.module.css"

const keybaseLogoStyle = {
    height: "28px",
};
const linkedInLogoStyle = {
    height: "28px",
};

const linkNoBoxShadowStyle = {
    boxShadow: "none",
};

class AboutPage extends Component {
    constructor() {
        super();
        this.state = {
            messageFrameVisible: false
        }
    }

    showMessageFrame() {
        this.setState({ messageFrameVisible: true });
    }


    render() {
        return (
            <Container
                style={{
                    maxWidth: rhythm(24),
                    padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
                    margin: "20vh auto",
                }}
                className={styles.card}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start"
                    }}
                >
                    <div >
                        <img src={avatar} className={styles.avatar} />
                    </div>
                    <h3
                        style={{
                            marginTop: `${rhythm(0.5)}`
                        }}
                    >Hi, I am <strong>Biswa</strong>; a software dev currently <br />in Sydney, Australia</h3>
                    <hr />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                        }}
                    >
                        <span>
                            You can reach me at:
                        </span>
                        <div
                            style={{
                                display: "flex",
                                flexGrow: "2",
                                flexWrap: "wrap",
                                flexDirection: "row",
                                justifyContent: "space-evenly",
                                minWidth: "100px"
                            }}
                        >
                            <a href="https://www.linkedin.com/in/biswadahal" style={linkNoBoxShadowStyle}>
                                <img src={linkedInLogo} style={linkedInLogoStyle} />
                            </a>
                            <a href="https://keybase.io/biswadahal" style={linkNoBoxShadowStyle}>
                                <img src={keybaseLogo} style={keybaseLogoStyle} />
                            </a>

                        </div>
                        <div>
                            <span>Or, <a href="#msg" onClick={() => this.showMessageFrame()}>Send a message</a></span>
                        </div>

                    </div>
                </div>
                <div id="msg"
                    className={
                        this.state.messageFrameVisible === true ? styles.showMsg : styles.hideMsg
                    }
                >
                    <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLSdkc7xPaXXhEB8VPkhCZMYOXTeoxYxUlMsQep0RYEBF4ZdrpA/viewform?embedded=true"
                        className={styles.messageForm}
                        scrolling="no"
                        frameborder="0"
                        marginheight="0"
                        marginwidth="0">
                        Loading Message Form...
                    </iframe>
                </div>
            </Container >
        );
    }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/components/about.js